import { ComponentPropsWithoutRef, ElementType, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { Dot } from './Dot';
import { LegendElement } from './types';

type LegendItemProps<T extends ElementType> = {
  className?: string;
  as?: T;
} & ComponentPropsWithoutRef<T> &
  LegendElement;

const LegendItemComp = <T extends ElementType>({ as, color, name, className, ...rest }: LegendItemProps<T>) => {
  const Component = as || 'div';

  return (
    <Component className={twMerge('flex items-center gap-2 text-sm', className)} {...rest}>
      <Dot color={color} />
      <p className='text-sm text-tertiary-600 first-letter:capitalize'>{name}</p>
    </Component>
  );
};

export const LegendItem = memo(LegendItemComp);
